import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Media } from 'react-bootstrap';
import Layout from '../../components/Layout';
import { DE } from '../../Languages/DE';
import { EN } from '../../Languages/EN';
import LanguageContext from '../../helper/LanguageContext';
import { callAPI } from "../../helper/apiUtils";
import { requestDirectMessage } from "../../helper/directMessagePrompt";
import { BASE_URL } from "../../helper/constants";
import { useSelector } from "react-redux";
import { convertBranchRole } from '../../helper/convertor';
import "./CompanyServicesMember.css";

function CompanyServicesMember(props) {

    const { isGerm, strings } = React.useContext(LanguageContext)
    const history = useHistory();
    const [users, setUsers] = useState([])
    const [isKjuup, setIsKjuup] = useState([])

    useEffect(() => {
        if (props.location.state) {
            setIsKjuup(props.location.state.isKjuup)
        }
    }, [props])
    const getUserList = async () => {
        const id = props.match.params.id
        const { data } = await callAPI(`/service/${id}/member`, {}, 'GET')
        console.log(data)
        await setUsers(data.members)
    }
    useEffect(() => {
        getUserList();

    }, [props.match.params.id])
    const getUserDetails = (person) => {
        const id = person?.id || person;
        if (!id) return;
        requestDirectMessage({
            id,
            fullName: person?.fullName,
            avatar: person?.avatar,
        });
    }

    const isDeskTopResolution = useSelector(state => state.isDeskTopResolution)
    return (
        <React.Fragment>
                <div className={`following article_like company-services-member d-flex flex-column${isDeskTopResolution ? " company-services-member--desktop" : ""}`}>
                    <div onClick={() => {
                        history.goBack()
                    }} className={isKjuup ? "main_heading main_heading-internal company-services-member__heading" : "main_heading company-services-member__heading"}>
                        <span className={`material-symbols-outlined material-arrow-left ${isKjuup ? 'internal-arrow' : ''}`}>
                          keyboard_arrow_left
                        </span>
                        {strings.who_has_confirmed_services}
                    </div>
                    {
                        users &&
                        users.map(user => (
                            <div key={user?.id} className="post_notification">
                                <div className="my_post company-services-member__post">
                                    <Media>
                                        <img
                                            width={30}
                                            height={30}
                                            className={`mr-3 company-services-member__avatar${(user.isKjuup || user.companies?.some(c => c.isKjuup)) ? " company-services-member__avatar--internal" : ""}`}
                                            src={
                                                user.avatar ? BASE_URL + user.avatar : process.env.PUBLIC_URL + "/assets/img/head.svg"
                                            }
                                            alt="Generic placeholder"
                                        />
                                        <Media.Body>
                                            <div className="authore_name">
                                                <h5 className="pointer"
                                                    onClick={e => getUserDetails(user)}> {user.fullName}</h5>
                                                <p>{convertBranchRole(user.buildingIndustryRole, isGerm)}</p>
                                            </div>
                                        </Media.Body>
                                    </Media>
                                </div>
                            </div>
                        ))
                    }

                </div>
        </React.Fragment>
    );
}

export default CompanyServicesMember;
